import { curveCardinal, line } from "d3";

export const STEP_SIZE = 0.75;
export const WIDTH_MULTIPLIER = 1.75;

const dribbleLineGenerator = line<SVGPoint>()
  .x((d) => d.x)
  .y((d) => d.y)
  .curve(curveCardinal);

export interface GetDribblePathProps {
  pathLine: string;
  widthMultiplier?: number;
  stepSize?: number;
  classicMarkerHead?: boolean;
}

export const getDribblePath = ({
  pathLine,
  widthMultiplier = WIDTH_MULTIPLIER,
  stepSize = STEP_SIZE,
  classicMarkerHead = false,
}: GetDribblePathProps) => {
  const pathElement = document.createElementNS("http://www.w3.org/2000/svg", "path");
  pathElement.setAttribute("d", pathLine);

  const totalLength = pathElement.getTotalLength();
  const numOfSteps = Math.floor(totalLength / stepSize + 2) - (classicMarkerHead ? 0 : 2);

  const points = Array.from(Array(numOfSteps), (_, i) => i)
    .map((i) => pathElement.getPointAtLength(i * stepSize))
    .map((point, i, arr) => {
      const prevPoint = arr[i - 1];
      if (!prevPoint || i === arr.length - 1) return point;

      const dx = point.x - prevPoint.x;
      const dy = point.y - prevPoint.y;

      const dTotal = (Math.abs(dx) + Math.abs(dy)) * widthMultiplier;

      const shiftX = dy / dTotal;
      const shiftY = dx / dTotal;

      const isEven = i % 2 === 0;

      const newX = isEven ? point.x - shiftX : point.x + shiftX;
      const newY = isEven ? point.y + shiftY : point.y - shiftY;

      return { ...point, x: newX, y: newY };
    });

  pathElement.remove();

  const d = dribbleLineGenerator(points);

  return { dribblePath: d || "M 0 0", dribblePoints: points };
};
